import {Component, EventEmitter, Inject, Input, Output} from '@angular/core';
import { BZG_MODAL_DATA, BzgModalRef } from 'bz-genome-angular';
import { IFilterColumn } from '../IFilterColumn';

@Component({
  selector: 'jobs-filter',
  templateUrl: 'jobs-filter.component.html',
  styleUrls: ['jobs-filter.component.scss']
})
export class JobsFilterComponent {
  public columnsToFilter: Array<IFilterColumn>;

  constructor(public modalComponentRef: BzgModalRef,
    @Inject(BZG_MODAL_DATA) public data: { columns: Array<IFilterColumn> }) {
      this.columnsToFilter = _.cloneDeep(data.columns);
    }

  async ngOnInit() {
  }

  public apply() {
    this.modalComponentRef.close({columns:this.columnsToFilter});
  }

  public close() {
    this.modalComponentRef.close();
  }

  public clearAll() {
    _.forEach(this.columnsToFilter, (column: IFilterColumn) => {
      if (!column.blocked) {
        column.visible = false;
      }
    })
  }

  public change(col: IFilterColumn, event) {
    if (!event.target) {
      col.visible = event;
    }
  }
}
